import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FilterType } from "../../../models/enums";
import { FilterService } from "../../../services/filter.service";

@Component({
  standalone: false,
  selector: "dua-filter-button",
  templateUrl: "./filter-button.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./filter-button.component.scss"],
})
export class FilterButtonComponent implements OnInit {
  @Input() displayValue!: string;
  @Input() filterType!: FilterType;
  @Input() additionalClass!: string;
  @Input() open!: boolean;
  @Output() toggleFilter = new EventEmitter<{ open: boolean; event: Event }>();

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.filterService.getCurrentOpenedFilterChanged().subscribe((change) => {
      this.open = change == this.filterType;
    });
  }

  isDisabled(): boolean {
    return this.filterService.isDisabled();
  }

  toggleOpen(event: Event) {
    this.open = !this.open;
    this.toggleFilter.emit({ open: this.open, event });
  }
}
